export default __webpack_public_path__ + "static/SaintsandStars-pricing-b2d28410599a9fbebc15f6c67229f1e3.jpg";